import React, { useState } from 'react';

import clsx from 'clsx';

import SectionHeader from 'components/LoanPortal/SectionHeader';

import styles from '../Sections.module.scss';
import { SubSectionState } from '../SubSection/SubSection';

export interface SectionProps {
  title: string;
  subSectionStates: SubSectionState[];
}

const Section = ({ title, subSectionStates, children }: React.PropsWithChildren<SectionProps>) => {
  const sectionExist = subSectionStates.some((subSection) => subSection.isExist);
  const sectionCompleted = subSectionStates.every((subSection) => (subSection.isExist ? subSection.isCompleted : true));

  const [isOpened, setIsOpened] = useState(sectionCompleted);

  return sectionExist ? (
    <>
      <div className={styles.sectionContainer}>
        <SectionHeader headerTitle={title} handleRollUpSection={() => setIsOpened(!isOpened)} isRolledUp={isOpened} />

        <div
          className={clsx(styles.formContainer, {
            [styles.formContainerHidden]: isOpened,
          })}
        >
          {children}
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default Section;
